export const GetFundByIDActionTypes = {
  GET_FUND_BY_ID_LOADING: "GET_FUND_BY_ID_LOADING",
  GET_FUND_BY_ID_ERROR: "GET_FUND_BY_ID_ERROR",
  GET_FUND_BY_ID_SUCCESS: "GET_FUND_BY_ID_SUCCESS",
};
